require("!!F:\\PKP\\FMCOLL\\web-rest\\action-web\\node_modules\\script-loader\\addScript.js")(require("!!F:\\PKP\\FMCOLL\\web-rest\\action-web\\node_modules\\raw-loader\\index.js!F:\\PKP\\FMCOLL\\web-rest\\action-web\\node_modules\\chroma-js\\chroma.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/chroma-js/chroma.js
// module id = 842
// module chunks = 3